import type React from 'react';
import { Suspense, useEffect, useState } from 'react';
import { lazyReactNaiveRetry } from '../../../constants/Lazy';
import type { AppSsrFetchedDataType } from '../../../server/AppSsr';

const Appointments = lazyReactNaiveRetry(() => import('./Appointments'));

interface AppointmentsPageProps {
  ssrFetchedData: AppSsrFetchedDataType;
}

const AppointmentsPage: React.FC<AppointmentsPageProps> = ({
  ssrFetchedData,
}) => {
  const [onClient, setOnClient] = useState<boolean>(false);

  useEffect(() => {
    setOnClient(true);
  }, []);

  return onClient ? (
    <Suspense fallback={<div className="hidden">&nbsp;</div>}>
      <Appointments ssrFetchedData={ssrFetchedData} />
    </Suspense>
  ) : null;
};

export default AppointmentsPage;
